import React, { Component } from "react";
import ContractQualityAssuranceForm from "./ContractQualityAssuranceForm";
import SmallModal from "../../../../hoc/UI/SmallModal/SmallModal";
import { Button } from "rsuite";

class ContractQualityAssurance extends Component {
  state = {
    proj_contract_quality_assurance_id: null
  };

  componentDidMount() {
    this.props.contractQualityAssurance.fetch();
  }
  render() {
    let smallModal = null;
    if (this.props.showSmallModal) {
      smallModal = (
        <SmallModal>
          <ContractQualityAssuranceForm
            toggleSmallModalHandler={this.props.toggleSmallModalHandler}
            currentContractQualityAssurance={
              this.state.proj_contract_quality_assurance_id === null
                ? null
                : this.props.contractQualityAssurance.contractQualityAssurance.find(
                    contractQualityAssurance =>
                      contractQualityAssurance.proj_contract_quality_assurance_id ===
                      this.state.proj_contract_quality_assurance_id
                  )
            }
            update={this.props.contractQualityAssurance.update}
            add={this.props.contractQualityAssurance.add}
            projectID={this.props.currentProjectID}
            disabled={this.props.disabled}
          />
        </SmallModal>
      );
    }
    return (
      <div>
        {this.props.disabled ? null : (
          <div style={{ textAlign: "right" }}>
            <Button
              color={"blue"}
              className={"my-2"}
              onClick={() => {
                this.setState({ proj_contract_quality_assurance_id: null });
                this.props.toggleSmallModalHandler();
              }}
            >
              Create New Contract Quality Assurance
            </Button>
          </div>
        )}
        {smallModal}

        <table className={"table"}>
          <thead>
            <tr>
              <th>Non-Conformance Work</th>
              <th>Non-Conformance work Correction</th>
              <th>Notes</th>
              {this.props.disabled ? null : <th>Delete</th>}
            </tr>
          </thead>
          <tbody>
            {this.props.contractQualityAssurance.contractQualityAssurance.map(
              item => (
                <tr
                  key={item.proj_contract_quality_assurance_id}
                  onClick={e => {
                    if (e.target.type !== "button") {
                      this.setState({
                        proj_contract_quality_assurance_id:
                          item.proj_contract_quality_assurance_id
                      });
                      this.props.toggleSmallModalHandler();
                    }
                  }}
                >
                  <td>{item.non_conformance_work}</td>
                  <td>{item.non_conformance_work_correction}</td>
                  <td>{item.notes}</td>
                  {this.props.disabled ? null : (
                    <td>
                      <Button
                        color="blue"
                        type="button"
                        onClick={() => {
                          this.setState({
                            contractQualityAssurance:
                              item.contractQualityAssurance
                          });
                          this.props.toggleSmallModalHandler();
                        }}
                      >
                        Edit
                      </Button>{" "}
                      <Button
                        color="red"
                        type="button"
                        onClick={() =>
                          this.props.contractQualityAssurance.delete(
                            item.proj_contract_quality_assurance_id,
                            this.props.currentProjectID
                          )
                        }
                      >
                        Delete
                      </Button>
                    </td>
                  )}
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ContractQualityAssurance;
